/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_DescriptionInputs */



/**
* | output |
* | --- |
* | "Meet the team behind AWP Marine Consultancy." |
*
* @param {Team_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_description = /** @type {((inputs?: Team_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("认识 AWP Marine Consultancy 背后的团队。")
	return /** @type {LocalizedString} */ ("Meet the team behind AWP Marine Consultancy.")
});